<template>
  <div class="text-xs">
    <div class="py-4 text-center text-2xl font-bold text-black">
      {{ title }}
    </div>
    <div class="w-full my-2 text-sm">
      <div class="text-md px-10 text-black my-2">
        {{ caption }}
      </div>
    </div>
    <div class="border-b-2 border-gray-500 pb-6 px-10">
      <input
        type="text"
        v-model="oneTimePw"
        class="text-md bg-white w-full p-2 mb-2 border-solid border-2 border-gray-900"
      />
      <v-btn color="primary" class="w-full" @click="submit">Submit</v-btn>
    </div>
    <div class="rounded p-2 ">
      <div class="text-center text-black">
        {{ note }}
      </div>
      <div class="text-center my-2">
        <v-btn @click="BISSelectionComponent" 
          >Update info</v-btn
        >
      </div>
      <div class="text-black">
        Is your registered email inactive? Update your information here.
      </div>
    </div>
  </div>
</template>
<script>
// import EventBus from "@/EventBus";

export default {
  data() {
    return {
      oneTimePw: "",
      title: "ONE-TIME-PIN (OTP)",
      caption:
        "Enter the One-Time-Pin sent to your registered e-mail with Moldex",
      note:
        "Did you change your mobile number? Submit your new registered contact information here.",
    };
  },
  methods: {
    BISSelectionComponent() {
      this.$emit("openBISSelection", true);
    },
    submit() {
      if (!this.oneTimePw) {
        var msg = "Please enter your OTP";
        alert(msg);
      } else {
        // EventBus.$emit("OPEN_PW_DIALOG");
        this.$emit("enterOTP", this.oneTimePw);
      }
    },
  },
};
</script>
